
import { Component, OnInit, } from '@angular/core';
import { ModalController,NavParams } from '@ionic/angular';
import * as sha1 from 'sha1';
import { ObjetService } from 'src/app/service/objet.service';
import { objet } from 'src/app/model/objet.model';
import { CustomLoadingService } from 'src/app/service/custom-loading.service';
import { Context } from 'src/app/shared/services/context.service';
import * as pdfjsLib from 'pdfjs-dist';
import { Orientation, OrientationService } from 'src/app/service/orientation.service';
@Component({
  selector: 'app-upload-photo',
  templateUrl: './upload-photo.component.html',
  styleUrls: ['./upload-photo.component.scss'],
})
export class UploadPhotoComponent implements OnInit {
  fileList : File; 
  idUser; 
  ContextFolder; 
  base64textString;
  binaryString: string;
  destName; 
  form ; 
  tabNewImage : objet[]=[]; 
  public newImage; 
  arrayFile: {file : File , test : boolean , image : string} []=[]; 
  imageUrlPrefix;
  showBtn: boolean = false;
  reloadImages: boolean = false;
  ListImageAdded : any = []
  constructor(private navParam: NavParams, public modalController: ModalController , private objetService: ObjetService,
    private customLoadingService: CustomLoadingService,
    private orientationService: OrientationService
  ) 
  {  
    this.idUser = navParam.data.idUser;
    this.ContextFolder = navParam.data.ContextFolder;
    this.fileList = navParam.data.fileList;
    }   
 
 async ngOnInit() {
      this.customLoadingService.presentLoading();
      (await this.getListPhoto()).toPromise().then(res=>{
        this.listPhoto=res
        this.onFileSelected().then(()=>{
        })
      })
      this.ListImageAdded = [];
  }
 
  
async createDossierPatient(path)
{
  this.objetService.createDossierPatient(path).subscribe(value=>{
  },error=>{
   });
}

insertObjet(nom, extension, id_patient1, vignette, width,
  height, taille, estidentite, dateCreation, echelle, fichier, lastModif,
  repStockage, syncPath, dateInsertion, auteur, idGabarit , id_patient_orthalis) {
    let obj : objet = new objet();
  obj.nom = nom;
  obj.extension = extension;
  obj.id_patient = id_patient1;
  obj.vignette = vignette;
  obj.width = width;
  obj.height = height;
  obj.taille = taille;
  obj.estidentite = estidentite;
  obj.dateCreation = dateCreation;
  obj.echelle = echelle;
  obj.fichier = fichier;
  obj.lastModif = lastModif;
  obj.repStockage = repStockage;
  obj.syncPath = syncPath;
  obj.dateInsertion = dateInsertion;
  obj.auteur = auteur;
  obj.idGabarit = idGabarit;
  obj.id_patient_orthalis= id_patient_orthalis; 
  obj.pkObjet = 0;
  return  this.objetService.addObjet(obj)
}
async convertImageToWebP(imageBlob: Blob): Promise<any> {
  // Ensure the input is a valid Blob
  if (!(imageBlob instanceof Blob)) {
    return Promise.reject(new Error("Provided input is not a valid Blob"));
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    // Handle successful read
    reader.onload = (event) => {
      const target = event.target as FileReader; // Type assertion for FileReader
      if (target.result) {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext("2d");
          if (ctx) {
            ctx.drawImage(img, 0, 0);

            // Convert the canvas content to a WebP Blob
            canvas.toBlob(
              (webpBlob) => {
                if (webpBlob) {
                  resolve(webpBlob); // Resolve with the WebP Blob
                } else {
                  reject(new Error("Failed to create WebP Blob"));
                }
              },
              "image/webp" // Specify the WebP format
            );
          } else {
            reject(new Error("Failed to get canvas context"));
          }
        };

        img.onerror = () => reject(new Error("Failed to load image"));
        img.src = target.result as string; // Set the image source
      } else {
        reject(new Error("Failed to read file data"));
      }
    };

    // Handle FileReader errors
    reader.onerror = () => reject(new Error("FileReader encountered an error"));
    reader.readAsDataURL(imageBlob); // Read the Blob as a data URL
  });
}




// Fonction pour convertir une image WebP en JPEG
async convertWebPToJpeg(webpFile: File): Promise<any> {
  if (!(webpFile instanceof File)) {
    throw new Error("Provided input is not a valid File.");
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    // Read the WebP file as a Data URL
    reader.onload = (event) => {
      const target = event.target as FileReader; // Cast event.target to FileReader
      if (target.result) {
        const image = new Image();

        image.onload = () => {
          // Create a canvas with the same size as the image
          const canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;

          const ctx = canvas.getContext("2d");
          if (!ctx) {
            reject(new Error("Unable to get canvas context."));
            return;
          }

          // Draw the image onto the canvas
          ctx.drawImage(image, 0, 0);

          // Convert the canvas content to a JPEG Blob
          canvas.toBlob(
            (blob) => {
              if (blob instanceof Blob) {
                resolve(blob); // Resolve with the Blob
              } else {
                reject(new Error("Failed to create JPEG Blob."));
              }
            },
            "image/png",
            0.8 // Set JPEG quality to 80%
          );
        };

        image.onerror = () => reject(new Error("Failed to load the WebP image."));
        image.src = target.result as string; // Set the image source to the Data URL
      } else {
        reject(new Error("FileReader result is empty."));
      }
    };

    reader.onerror = () => reject(new Error("Failed to read the WebP file."));
    reader.readAsDataURL(webpFile); // Convert the file to a Data URL
  });
}



async uploadImage(file: File) {

  this.orientationService.getOrientation(file).subscribe(
  async (value: Orientation) => {

    if (value.predicted_angle != 0 && value.confidence == 1.0) {
      file = await this.orientationService.rotateImage(file, -value.predicted_angle);
    }

    let processedFile = file;

    // Si c'est du WebP → convertir en JPEG directement
    if (file.type === "image/webp") {
      const jpegBlob = await this.convertWebPToJpeg(file);
      processedFile = new File(
        [jpegBlob],
        file.name.replace(".webp", ".png"),
        { type: "image/png" }
      );
    }

    // Lire en base64
    const base64Data = await this.readFileAsBase64(processedFile);
    const destName = sha1(base64Data);

    // On garde le fichier tel quel (JPEG/PNG)
    const form = new FormData();
    form.append("file", processedFile, destName + ".png");

    const result = await Promise.all([
      this.objetService
        .saveImage(destName + ".png", this.ContextFolder + this.idUser, form)
        .toPromise(),

      this.insertObjet(
        destName + ".png",
        "png", // format sauvegardé
        +this.idUser,
        base64Data,
        0, 0, 0, 0, null, 0,
        destName + ".png",
        "",
        this.ContextFolder + this.idUser,
        "",
        "",
        "",
        0,
        this.idUser
      )
        .toPromise()
        .then(res => {
          if (res !== null) {
            console.log("res", res);
            this.ListImageAdded.push(res);
            this.arrayFile.push({ file: file, test: false, image: res.vignette });
            this.showBtn = true;
          }
          this.tabNewImage.push(res);
        })
    ]);

    this.reloadImages = true;
    this.newImage = result[1];

    }
  );

}


generateRandomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
}



async saveToBasePhoto(blob: any) {
  // const arrayBuffer = await blob.arrayBuffer();
  const destName = 'upload_' + this.generateRandomString(20);
  pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.min.js";
  const pdfDoc = await pdfjsLib.getDocument({ url: URL.createObjectURL(blob) }).promise.then(async (pdf) => {
    const page = await pdf.getPage(1);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext("2d");
    const viewport = page.getViewport({ scale: 1 });
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    const renderContext = {
      canvasContext: canvas.getContext('2d'),
      viewport: viewport,
    };
    await page.render(renderContext).promise.then( async () => {
      const imageDataURL = canvas.toDataURL('image/png', 25);
      const image = imageDataURL.replace("data:image/png;base64,", "");
      await this.insertObjet(
        destName + ".pdf", ".pdf", +localStorage.getItem('idPatient'), image, 141, 200, 0, 0, null, 1, destName + ".pdf", "", Context.folder + localStorage.getItem('idPatient'), "", "", "", 0, localStorage.getItem('idPatient')
      ).toPromise().then(res=>{
        if (res !== null) {
          console.log('res', res);
          this.ListImageAdded.push(res);
          this.arrayFile.push({ file: blob, test: false, image: res.vignette });
          this.showBtn = true;
      }
      this.tabNewImage.push(res);
      });
    });
  });  

  var form = new FormData();
  form.append("file", blob);
  this.objetService
      .saveImage(destName + ".pdf", Context.folder + localStorage.getItem('idPatient'), form)
      .subscribe();
}

async onFileSelected() {
  if (Object.values(this.fileList).length == 0) {
      return this.dismissModal();
  }

  this.createDossierPatient("/" + this.ContextFolder + this.idUser);

  try {
    console.log('this.fileList', this.fileList);

    for (const f of Object.values(this.fileList)) {
        await new Promise<void>((resolve, reject) => {
            if (f.type.startsWith('image')) {
                this.uploadImage(f).then(() => resolve()).catch(error => reject(error));
            }  else if (f.type === 'application/pdf' || f.type === '') {
              // Vérification par extension pour les PDFs et STL
              if (f.name.toLowerCase().endsWith('.pdf')) {
                  this.saveToBasePhoto(f).then(() => resolve()).catch(error => reject(error));
              } else if (f.name.toLowerCase().endsWith('.stl')) {
                  this.saveSTLFile(f).then(() => resolve()).catch(error => reject(error));
              } else {
                  reject(new Error('Unsupported file type'));
              }
            }
              else {
                reject(new Error('Unsupported file type'));
            }
        });
    }

    await this.dismissLoading();
  } catch (e) {
      console.error(e);
      this.dismissLoading();
  }
}





async saveSTLFile(blob: any) {
  const destName = 'upload_' + this.generateRandomString(20) + ".stl";
  
  // Définir une vignette statique pour les fichiers STL
  const staticVignette = "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"; // Remplace par ton URL

  try {
    // Création de l'objet avec la vignette statique
    // const base64Vignette = await this.getBase64FromUrl(staticVignette);
    await this.insertObjet(
      destName,               // Nom du fichier
      ".stl",                 // Extension
      +localStorage.getItem('idPatient'), 
      staticVignette,         // Vignette statique
      141, 200, 0, 0, null, 1, 
      destName, "", 
      Context.folder + localStorage.getItem('idPatient'), 
      "", "", "", 0, localStorage.getItem('idPatient')
    ).toPromise().then(res => {
      if (res !== null) {
        console.log('Fichier STL enregistré avec vignette statique:', res);
        this.ListImageAdded.push(res);
        this.arrayFile.push({ file: blob, test: false, image: staticVignette }); // Utilisation de la vignette statique
        this.showBtn = true;
        this.tabNewImage.push(res);
      }
    });

    // Envoi du fichier STL au backend
    var form = new FormData();
    form.append("file", blob);
    await this.objetService
      .saveImage(destName, Context.folder + localStorage.getItem('idPatient'), form)
      .toPromise();

    console.log('Fichier STL uploadé avec succès !');
  } catch (error) {
    console.error('Erreur lors de l\'upload du fichier STL:', error);
  }
}

readFileAsBase64(file: File): Promise<string> {
  return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
          const readerResult = event.target as FileReader;
          if (readerResult && readerResult.result) {
              const result = readerResult.result as string;
              const base64Data = result.split(',')[1];
              resolve(base64Data);
          } else {
              reject(new Error("Failed to read the file."));
          }
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
  });
}



// async onFileSelected() {
//   if (Object.values(this.fileList).length == 0) {
//       return this.dismissModal();
//   }

//   this.createDossierPatient("/" + this.ContextFolder + this.idUser);

//   try {
//       console.log('this.fileList',this.fileList);
      
//       for (const f of Object.values(this.fileList)) {
//           await new Promise<void>((resolve, reject) => {
//               const reader = new FileReader();
//               reader.onload = async (readerEvt: any) => {
//                   const base64Data = readerEvt.target.result.split(',')[1]; // Get base64 data excluding the data URL prefix

//                   let contentType: string;
//                   let extension: string;

//                   if (f.type.startsWith('image')) {
//                       contentType = 'image/png'; // Assume JPEG for simplicity
//                       extension = 'jpg'; // Assume JPG for simplicity
//                   } else if (f.type === 'application/pdf') {
//                       contentType = 'application/pdf';
//                       extension = 'pdf';
//                   } else {
//                       reject(new Error('Unsupported file type'));
//                       return;
//                   }

//                   const binaryString = atob(base64Data);
//                   const arrayBuffer = new ArrayBuffer(binaryString.length);
//                   const uint8Array = new Uint8Array(arrayBuffer);

//                   for (let i = 0; i < binaryString.length; i++) {
//                       uint8Array[i] = binaryString.charCodeAt(i);
//                   }

//                   const blob = new Blob([uint8Array], { type: contentType });

//                   const destName = sha1(base64Data);
//                   const form = new FormData();
//                   form.append("file", blob);

//                   let result;

//                   if (contentType.startsWith('image')) {
//                       result = await Promise.all([
//                           this.objetService.saveImage(destName + ".png", this.ContextFolder + this.idUser, form).toPromise(),
//                           this.insertObjet(destName + ".png", "jpg", +this.idUser, base64Data, 0, 0, 0, 0, null, 0,
//                               destName + ".png", "", this.ContextFolder + this.idUser, "", "", "", 0, this.idUser)
//                               .toPromise().then(res => {
//                                   if (res !== null) {
//                                       console.log('res', res);
//                                       this.ListImageAdded.push(res);
//                                       this.arrayFile.push({ file: f, test: false, image: res.vignette });
//                                       this.showBtn = true;
//                                   }
//                                   this.tabNewImage.push(res);
//                               })
//                       ]);
//                   } else if (contentType === 'application/pdf') {
//                     result = await Promise.all([
//                       this.objetService.saveImage(destName + ".pdf", this.ContextFolder + this.idUser, form).toPromise(),
//                       this.insertObjet(destName + ".pdf", "pdf", +this.idUser, base64Data, 0, 0, 0, 0, null, 0,
//                           destName + ".pdf", "", this.ContextFolder + this.idUser, "", "", "", 0, this.idUser)
//                           .toPromise().then(res => {
//                               if (res !== null) {
//                                   console.log('res', res);
//                                   this.ListImageAdded.push(res);
//                                   this.arrayFile.push({ file: f, test: false, image: res.vignette });
//                                   this.showBtn = true;
//                               }
//                               this.tabNewImage.push(res);
//                           })
//                   ]);
//                   }

//                   this.reloadImages = true;
//                   this.newImage = result[1];
//                   resolve(); // Resolve the promise to proceed to the next iteration
//               };

//               reader.onerror = (error) => {
//                   reject(error); // Reject the promise if there is an error
//               };
              
//               if (f.type.startsWith('image')) {
//                   reader.readAsDataURL(f); // Read image files as data URL
//               } else if (f.type === 'application/pdf') {
//                   reader.readAsBinaryString(f); // Read PDF files as binary strings
//               }
//           });
//       }

//       await this.dismissLoading(); // Dismiss loading after all files are processed
//   } catch (e) {
//       console.error(e);
//       this.dismissLoading();
//   }
// }


async dismissLoading() {
  await this.customLoadingService.dismissLoading();
}


listPhoto = []; 
async getListPhoto(){
 return this.objetService.listphoto(this.idUser)
}
dismissModal() {
  this.customLoadingService.dismissLoading();
  if(this.reloadImages) {
    this.modalController.dismiss(this.ListImageAdded);
    this.reloadImages = false;
  } else
  this.modalController.dismiss();
}

}